import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

export const getDocumentAttachmentsQueryOptions = (args: {
  documentId: string
}) =>
  queryOptions({
    queryKey: ['document-attachments', args],
    queryFn: () =>
      apiClient.documents[':documentId'].attachments
        .$get({ param: { documentId: args.documentId } })
        .then((r) => formatClientResponse(r)),
  })

export const useGetDocumentAttachments = (
  args: { documentId: string },
  options?: Partial<ReturnType<typeof getDocumentAttachmentsQueryOptions>>
) =>
  useQuery({
    ...getDocumentAttachmentsQueryOptions(args),
    ...options,
  })
